import { FunctionBrick, registerBrick } from 'olympe';

export default class GetLocalStorage extends FunctionBrick {

    /**
     * Executed every time an input (key) gets updated.
     * Note that this method will _not_ be executed if an input value is undefined.
     * 
     * @protected
     * @param {BrickContext} context
     * @param {string} key
     * @param {function(string)} setValue
     */
    onUpdate(context, [key], [setValue]) {
        // Making sure the browser support local storage
        if (typeof Storage !== 'undefined') {
            setValue(localStorage.getItem(key));
        } else {
            throw new Error(`Your browser does not support the window.localStorage API`);
        }
    }
}

registerBrick('017a43279f568f40e2d6', GetLocalStorage);
